const texts = {
    RODO_section_first: `
        Administratorem danych osobowych jest Gdańskie Wydawnictwo Oświatowe spółka
        z&nbsp;ograniczoną odpowiedzialnością sp. k., Al. Grunwaldzka 50A, 80-241 Gdańsk
        (GWO). Podanie danych osobowych jest dobrowolne. Brak podania danych
        uniemożliwi skontaktowanie się z&nbsp;Państwem i&nbsp;udzielenie odpowiedzi na pytania
        zadane poprzez formularz kontaktowy. Dane osobowe będą przetwarzane na
        podstawie art. 6 ust. 1 lit. a) RODO w&nbsp;celu udzielenia odpowiedzi na pytania
        zadane przez formularz kontaktowy i&nbsp;zostaną usunięte na koniec roku
        kalendarzowego następującego po roku, w&nbsp;którym zadano pytanie. Dane mogą być
        również przetwarzane w&nbsp;tym czasie na podstawie art. 6 ust. 1 lit. f) RODO do
        celów marketingu bezpośredniego. Na tej samej podstawie dane mogą być
        przetwarzane w&nbsp;celu ustalenia, dochodzenia lub obrony roszczeń, do czasu
        przedawnienia roszczeń. Odbiorcami danych mogą być podmioty zajmujące się
        obsługą informatyczną i&nbsp;udostępniające GWO narzędzia informatyczne, podmioty
        zajmujące się zarządzaniem i&nbsp;wprowadzaniem danych do baz, pośredniczące
        w&nbsp;realizowaniu akcji marketingowych lub świadczące usługi doradcze. Masz prawo
        dostępu do tych danych, a&nbsp;także do ich sprostowania, usunięcia,
        przeniesienia, ograniczenia przetwarzania i&nbsp;do wniesienia skargi do Prezesa
        Urzędu Ochrony Danych Osobowych.
    `,
    RODO_section_second: `
        Masz prawo w dowolnym momencie wnieść sprzeciw wobec przetwarzania 
        danych z&nbsp;przyczyn związanych z&nbsp;Twoją szczególną sytuacją.
    `,
};

export default texts;
